var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 54,
    viewBox: "0 0 49 54",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0076FF",
    d: "M48.092 4.219H2.11V33.75h45.983L38.25 18.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF5FF",
    d: "m16.875 26.186-5.71-5.71 2.983-2.983 2.727 2.727 6.946-6.946 2.983 2.983z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47568C",
    d: "M2.11 0H0v54H4.219V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A4673",
    d: "M2.11 0h2.109v54h-2.11z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsFlag);
export default __webpack_public_path__ + "static/media/notifications-flag.0d0d4e3e27775fb0ec2cd78ee446a200.svg";
export { ForwardRef as ReactComponent };